import React from "react";
import styles from "./Label.scss";
import { LabelContext } from "./LabelContext";
import { ErrorState } from "../Types";
import { Error } from "./Error";

export interface FieldSetProps {
  /**
   * Content appearing after the control
   */
  label: string | JSX.Element;
  /**
   * Content appearing after the control
   */
  hint?: string | JSX.Element;
  /**
   * Error related to the control
   */
   error?: string | ErrorState<any> | null;

  /**
   * Adds an asterisk at the Label suffix
   */
  required?: boolean;
}

/**
 * Primary UI component for user interaction
 */
export const FieldSet: React.FC<FieldSetProps> = (props) => {
  return (
    <fieldset
      className={`${styles["au-fieldset"]} ${props.required ? styles["au-fieldset-required"] : ""
        }`}
    >
      <legend className={styles["au-fieldset__legend"]}>
        <label className={styles["au-label"]}>{props.label}
        {props.required && 
        <> 
          <span className={styles["au-label-required-icon"]} aria-hidden="true"></span>
          <span className="sr-only">Required</span>
        </>}  
        </label>
        {props.hint && !props.error && (
          <span className={styles["au-hint-text"]}>
            {props.hint}
          </span>
        )}
        {props.error && (
          <span className={styles["au-error-text"]}>
            <Error error={props.error}/>
          </span>
        )}
      </legend>
      <LabelContext.Provider
        value={{ state: props.error ? "invalid" : undefined }}
      >
        {props.children}
      </LabelContext.Provider>
    </fieldset>
  );
};
